'use client'

import { CheckCircle2 } from 'lucide-react'
import { useActionState } from 'react'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { passwordResetUrl } from '@/lib/config.client'
import { cn } from '@/lib/utils'
import { loginAction, type FormState } from '../_actions/login'
import { Logo } from './logo'

const initialState: FormState = {
  success: null,
}

export function LoginForm({ ...props }: React.ComponentPropsWithoutRef<'form'>) {
  const [state, action, isPending] = useActionState(loginAction, initialState)

  return (
    <form action={action} {...props}>
      <div className="flex flex-col gap-6">
        <div className="grid gap-2">
          <Label htmlFor="email">Email</Label>
          <Input
            name="email"
            id="email"
            type="email"
            placeholder="email@example.com"
            defaultValue={state?.inputs?.email}
            disabled={isPending}
            required
            className={cn(state?.errors?.email && 'border-red-500')}
          />
          {state?.errors?.email && <p className="text-sm text-red-500">{state?.errors.email}</p>}
        </div>
        <div className="grid gap-2">
          <div className="flex items-center">
            <Label htmlFor="password">Password</Label>
            <a
              href={passwordResetUrl}
              className="ml-auto inline-block text-sm underline-offset-4 hover:underline"
            >
              Forgot Email or Password?
            </a>
          </div>
          <Input
            name="password"
            id="password"
            type="password"
            defaultValue={state?.inputs?.password}
            disabled={isPending}
            placeholder="Password"
            required
            className={cn(state?.errors?.password && 'border-red-500')}
          />
          {state?.errors?.password && (
            <p className="text-sm text-red-500">{state?.errors.password}</p>
          )}
        </div>
        {state?.message && (
          <Alert variant={state?.success ? 'default' : 'destructive'}>
            {state?.success && <CheckCircle2 className="h-4 w-4" />}
            <AlertDescription>{state?.message}</AlertDescription>
          </Alert>
        )}
        <Button
          variant="secondary"
          disabled={isPending}
          type="submit"
          className="mt-4 w-full hover:bg-gray-300"
        >
          <Logo />
          Login
        </Button>
      </div>
    </form>
  )
}
